import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledChild = styled.div({
	marginTop: token('space.025'),
	marginRight: token('space.050'),
	marginBottom: token('space.025'),
	marginLeft: token('space.050'),
	minWidth: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const StyledListItemChild = styled.li({
	marginTop: token('space.050'),
	marginRight: token('space.025'),
	marginBottom: token('space.050'),
	marginLeft: token('space.025'),
	minWidth: 0,
	listStyle: 'none',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DialogInner = styled.div({
	width: '300px',
});
